import { Label, RadioGroup, RadioGroupItem } from '@massilia/ui'
import { useNavigate } from '@tanstack/react-router'

import type { LuggageFilterValue } from '@/lib/schemas/flight-results-search.schema'

import { Route } from '@/routes/_booking/vols.resultats'
import { useFilters } from '@/utils/use-search-params'

import { FilterDrawer } from './filter-drawer'

const LUGGAGE_OPTIONS: { label: string; value: LuggageFilterValue }[] = [
  { label: 'Sans bagage', value: 'none' },
  { label: '0 bagage et +', value: '0' },
  { label: '1 bagage et +', value: '1' },
  { label: '2 bagages et +', value: '2' },
]

interface LuggageFilterProps {
  shouldRefetchWithLuggage?: boolean
}

export function LuggageFilter({ shouldRefetchWithLuggage }: LuggageFilterProps) {
  const {
    filters: { filterLuggage, ...searchParams },
    setFilters,
  } = useFilters(Route.id)
  const navigate = useNavigate()

  const handleChange = (val: string) => {
    const needsRefetch =
      shouldRefetchWithLuggage && (val === '1' || val === '2')

    if (needsRefetch) {
      const updatedSearch = { ...searchParams.flightSearch, withLuggage: true }
      void navigate({
        reloadDocument: true,
        search: { ...searchParams, filterLuggage: val, flightSearch: updatedSearch },
        to: '/vols/resultats',
      })
    } else {
      setFilters({ filterLuggage: val })
    }
  }

  return (
    <FilterDrawer title="Bagage en soute inclus">
      <RadioGroup
        className="flex flex-col gap-2"
        onValueChange={handleChange}
        value={filterLuggage}
      >
        {LUGGAGE_OPTIONS.map((option) => (
          <Label
            className="flex cursor-pointer items-center gap-2"
            htmlFor={`luggage-${option.value}`}
            key={option.value}
          >
            <RadioGroupItem id={`luggage-${option.value}`} value={option.value} />
            <span className="text-sm text-gray-700">{option.label}</span>
          </Label>
        ))}
      </RadioGroup>
    </FilterDrawer>
  )
}
